'use client';

import React, { createContext, useState, ReactNode } from 'react';

interface ModalState {
  type:
    | 'VIDEO_MODAL'
    | 'SEED_MODAL'
    | 'LAND_MODAL'
    | 'CONGRATULATION_MODAL'
    | 'NEW_USER_MODAL'
    | 'PASSWORD_MODAL'
    | 'CHANGE_PASSWORD_MODAL'
    | 'PURCHASE_SUMMARY_MODAL'
    | 'GUARDARIAN_PAYMENT_MODAL'
    | 'SHOW_RECOVERY'
    | null;
  videoSrc?: string;
  isTest?: boolean;
}

interface ModalContextProps {
  modalState: ModalState;
  error: { passwordlessModalError: string; seedPhraseRecoveryError: string };
  setModalError: (passwordlessModalError: string, seedPhraseRecoveryError: string) => void;
  openModal: (state: ModalState) => void;
  closeModal: () => void;
}

const initialContext: ModalContextProps = {
  modalState: { type: null },
  error: { passwordlessModalError: '', seedPhraseRecoveryError: '' },
  setModalError: () => {},
  openModal: () => {},
  closeModal: () => {},
};

export const ModalContext = createContext<ModalContextProps>(initialContext);

interface ModalProviderProps {
  children: ReactNode;
}

export const ModalProvider = ({ children }: ModalProviderProps) => {
  const [modalState, setModalState] = useState<ModalState>({ type: null });
  const [error, setError] = useState<{
    passwordlessModalError: string;
    seedPhraseRecoveryError: string;
  }>({ passwordlessModalError: '', seedPhraseRecoveryError: '' });

  const openModal = (state: ModalState) => {
    setModalState(state);
  };

  const closeModal = () => {
    setModalState({ type: null });
    setError({ passwordlessModalError: '', seedPhraseRecoveryError: '' }); // Clear errors when modal is closed
  };

  const setModalError = (passwordlessModalError: string, seedPhraseRecoveryError: string) => {
    setError(prev => ({ ...prev, passwordlessModalError, seedPhraseRecoveryError }));
  };

  return (
    <ModalContext.Provider
      value={{
        modalState,
        error,
        setModalError,
        openModal,
        closeModal,
      }}
    >
      {children}
    </ModalContext.Provider>
  );
};
